export const secondsToHm = (seconds: number) => {
  const totalMinutes = seconds / 60;
  const hours = totalMinutes >= 60 ? totalMinutes / 60 : 0;
  const minutesRemainder = totalMinutes % 60;
  return `${Math.floor(hours)}h ${minutesRemainder.toFixed()}m`;
};
